import { SelectOption } from 'types/common'

export const fromAcquiredDateOptions: SelectOption[] = [
  { label: '特典獲得日から6ヶ月（180日）まで', value: '180' },
  { label: '特典獲得日から1年まで', value: (365 * 1).toString() },
  { label: '特典獲得日から2年まで', value: (365 * 2).toString() },
  { label: '特典獲得日から3年まで', value: (365 * 3).toString() },
  { label: '特典獲得日から4年まで', value: (365 * 4).toString() },
  { label: '特典獲得日から5年まで', value: (365 * 5).toString() },
]

export const fromLastAcquiredPointDateOptions: SelectOption[] = [
  { label: '最終ポイント取得日から6ヶ月（180日）まで', value: '180' },
  { label: '最終ポイント取得日から1年まで', value: (365 * 1).toString() },
  { label: '最終ポイント取得日から2年まで', value: (365 * 2).toString() },
  { label: '最終ポイント取得日から3年まで', value: (365 * 3).toString() },
  { label: '最終ポイント取得日から4年まで', value: (365 * 4).toString() },
  { label: '最終ポイント取得日から5年まで', value: (365 * 5).toString() },
]

export const POINT_CARD_COLORS = [
  '#5632BC',
  '#2A7589',
  '#258DC8',
  '#279A40',
  '#F8E220',
  '#EB691F',
  '#C23F32',
  '#E34373',
  '#231815',
  '#EEEEE3',
]

export const PER_PAGE = 50
